<template>
  <div>
    <el-button type="text" size="small" @click="openSee">
      <slot></slot>
    </el-button>

    <el-drawer
        :title="title"
        :visible.sync="openStatus"
        direction="rtl"
        size="90%"
        :append-to-body="true"
        :close-on-press-escape="false"
        :destroy-on-close="true"
        :wrapperClosable="true"
        :before-close="closeSee"
    >
      <div style="padding: 20px;">
        <el-table :data="list" border style="width: 100%">
          <el-table-column prop="mcu" label="MCU"></el-table-column>
          <el-table-column prop="bar_code" label="条码"></el-table-column>
          <el-table-column prop="name" label="产品名称"></el-table-column>
          <el-table-column prop="model_code" label="产品编码"></el-table-column>
        </el-table>
      </div>
    </el-drawer>

  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  components: {},
  data() {
    return {
      list: [],
      openStatus: false,
    };
  },
  computed: mapState({
    config: (state) => state.config,
  }),
  props: {
    info: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    }
  },
  mounted() {},
  methods: {
    // 筛选
    openSee() {
      const _this = this;
      _this.list = _this.info;
      _this.openStatus = true;
    },
    closeSee() {
      const _this = this;
      _this.list = [];
      _this.openStatus = false;
    },
  },
};
</script>